import confetti from 'canvas-confetti';

interface ConfettiOptions {
  particleCount?: number;
  spread?: number;
  origin?: { x?: number; y?: number };
  colors?: string[];
}

export function fireConfetti(options?: ConfettiOptions): void {
  confetti({
    particleCount: options?.particleCount ?? 100,
    spread: options?.spread ?? 70,
    origin: options?.origin ?? { y: 0.6 },
    colors: options?.colors,
  });
}

/**
 * Fire confetti from a specific element's position
 */
export function fireConfettiFromElement(
  element: HTMLElement,
  options?: Omit<ConfettiOptions, 'origin'>
): void {
  const rect = element.getBoundingClientRect();
  const originPoint = {
    x: (rect.left + rect.width / 2) / window.innerWidth,
    y: (rect.top + rect.height / 2) / window.innerHeight,
  };
  confetti({
    particleCount: options?.particleCount ?? 50,
    spread: options?.spread ?? 60,
    origin: originPoint,
    colors: options?.colors,
  });
}

/**
 * Fire celebration confetti with multiple bursts
 */
export function fireCelebration(): void {
  const originLeft = { x: 0 };
  const originRight = { x: 1 };
  // Fire from left
  confetti({
    particleCount: 50,
    angle: 60,
    spread: 55,
    origin: originLeft,
  });
  // Fire from right
  confetti({
    particleCount: 50,
    angle: 120,
    spread: 55,
    origin: originRight,
  });
}
